import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetOFCONUSWideByOrderId(orderId) {
  const response = await $.soap({
    body: {
      GetOFCONUSWideByOrderId: {
        $xmlns: 'http://dla.mil/ems/bpm/order/order_form',
        OrderId: orderId
      }
    },
    blueprint: {
      order: {
        orderId: '$..OrderID',
        customerSignature: '$..CustomerSignature',
        totalPrinterQuantity: '$..TotalPrinterQuantity',
        totalPrinterPrice: '$..TotalPrinterPrice',
        totalInkQuantity: '$..TotalInkQuantity',
        totalInkPrice: '$..TotalInkPrice',
        totalOrderQuantity: '$..TotalOrderQuantity',
        totalOrderPrice: '$..TotalOrderPrice',
        createdOn: '$..CreatedOn',
        createdBy: '$..CreatedBy',
        updatedOn: '$..UpdatedOn',
        updatedBy: '$..UpdatedBy',
        dateEquipmentReq: '$..DateEquipmentReq'
      }
    }
  });

  cleanUpResponse(response);
  return response.order;
}
